export enum candidateOperations {
  myProfileSkillsViewAllowed = 'myProfile-skills-viewAllowed',
  myProfileSkillsUpdateAllowed = 'myProfile-skills-updateAllowed',
}
